import gsap from 'gsap';
import { ease1 } from '../../easings';

const ANIMATION_SELECTORS = {
    APPEARANCE_ITEM: '.js-appearance-item',
};

const init = () => {
    const firstViewportTimeline = gsap.timeline({ defaults: { duration: 1, ease: ease1 } });

    firstViewportTimeline.fromTo(
        ANIMATION_SELECTORS.APPEARANCE_ITEM,
        { opacity: 0 },
        { opacity: 1, stagger: 0.5, duration: 1.5 },
    );
};

const _module = { init };

export default _module;
